import React, {useContext} from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {FormDataContext, FormValidationContext} from '@modifi/plugin-forms'

import {ConnectedFormFooter} from '../../../../plugins/onboarding/components/form-cta-footer'

type CompanyFormFooterProps = {
  loading: boolean
  hasError: boolean
  canMoveBack?: boolean
  handleBackButtonClick?: () => void
  handleForwardButtonClick: () => void
  disableSubmit?: boolean
  dataTargetSuffix?: string
}

const CompanyFormFooter: React.FC<CompanyFormFooterProps> = ({
  loading,
  hasError,
  canMoveBack = false,
  handleBackButtonClick,
  handleForwardButtonClick,
  disableSubmit = false,
  dataTargetSuffix = '',
}) => {
  const {hasChanges} = useContext(FormDataContext)
  const {triggerRevalidation, formIsValid} = useContext(FormValidationContext)
  const {t} = useTranslation('charon')

  const onForwardButtonClick = () => {
    if (formIsValid) handleForwardButtonClick()
    else triggerRevalidation && triggerRevalidation(undefined, 'form-submit')
  }

  return (
    <ConnectedFormFooter
      hasNavLock={false}
      loading={loading}
      hasError={hasError}
      hasCustomFormFooter
      hasBackButton={canMoveBack}
      canMoveBack={canMoveBack}
      onBackButtonClick={handleBackButtonClick}
      isAlwaysVisible
      hasForwardButton={!hasChanges}
      canMoveForward={!hasChanges}
      onForwardButtonClick={onForwardButtonClick}
      isFinalStep // submitting only saves - moving on is a separate click on the forward button
      submitLabel={
        hasChanges
          ? t('sub-section-footer.cta-save-continue')
          : t('sub-section-footer.cta-continue')
      }
      disableSubmit={disableSubmit}
      dataTargetSuffix={dataTargetSuffix}
    />
  )
}

export default CompanyFormFooter
